"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _core = require("@material-ui/core");
var _dates = require("../_utils/dates");
var _ListItem = _interopRequireDefault(require("./ListItem"));
var __jsx = _react.default.createElement;
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    actionArea: (0, _defineProperty2.default)({
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start'
    }, theme.breakpoints.up('md'), {
      flexDirection: 'column-reverse',
      justifyContent: 'flex-end'
    }),
    details: (0, _defineProperty2.default)({}, theme.breakpoints.up('md'), {
      marginTop: theme.spacing(1.25)
    }),
    ctaLink: (0, _defineProperty2.default)({
      width: '100%',
      minWidth: '144px',
      minHeight: '40px',
      marginTop: theme.spacing(3),
      padding: theme.spacing(2.5),
      backgroundColor: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: theme.palette.action.focus,
        textDecoration: 'none !important'
      },
      '& .MuiButton-label': {
        fontSize: theme.typography.pxToRem(16),
        color: theme.palette.common.white,
        fontWeight: theme.typography.fontWeightRegular
      }
    }, theme.breakpoints.up('md'), {
      margin: theme.spacing(6, 0, 5, 0),
      padding: theme.spacing(1.5, 6),
      width: '144px'
    })
  };
});
var buildSessionDetailList = function buildSessionDetailList(sessionsListProps, webinarType) {
  var sessionDetailList = [];
  var duration = sessionsListProps.duration,
    durationText = sessionsListProps.durationText,
    _sessionsListProps$la = sessionsListProps.language,
    language = _sessionsListProps$la === void 0 ? [] : _sessionsListProps$la,
    languageText = sessionsListProps.languageText,
    _sessionsListProps$se = sessionsListProps.sessionsList,
    sessionsList = _sessionsListProps$se === void 0 ? [] : _sessionsListProps$se,
    _sessionsListProps$se2 = sessionsListProps.sessionText,
    sessionText = _sessionsListProps$se2 === void 0 ? 'Session' : _sessionsListProps$se2,
    _sessionsListProps$pr = sessionsListProps.presentedText,
    presentedText = _sessionsListProps$pr === void 0 ? 'Presented' : _sessionsListProps$pr;
  if (duration) {
    var durationDetail = {
      detailLabel: durationText,
      detailValues: [duration]
    };
    sessionDetailList.push(durationDetail);
  }
  if (language.length > 0) {
    var commaSeperatedLanguages = language.join(', ');
    var languageDetail = {
      detailLabel: languageText,
      detailValues: [commaSeperatedLanguages]
    };
    sessionDetailList.push(languageDetail);
  }
  return [].concat(sessionDetailList, (0, _toConsumableArray2.default)(sessionsList.map(function (session, index) {
    var isUpcoming = !(0, _dates.isDateOlderThanToday)(session.timestamp);
    var sessionLabel = "".concat(webinarType === 'upcoming' ? sessionText + ' ' + (index + 1) : presentedText);
    var transformDateTime = function transformDateTime(input) {
      var _input = (0, _slicedToArray2.default)(input, 2),
        dateTimeString = _input[0],
        timezone = _input[1];
      var dateParts = dateTimeString.split(' ');
      var date = dateParts.slice(0, 4).join(' ');
      var time = dateParts.slice(4, -1).join('') + " ".concat(dateParts[dateParts.length - 1], ", ").concat(timezone);
      var presentedDate = dateParts.slice(0, 3).join(' ');
      return {
        date: date,
        presentedDate: presentedDate,
        time: time
      };
    };
    var input = [session.timestamp, session.timezone];
    var dateobj = transformDateTime(input);
    var sessionValues = [dateobj.date];
    if (isUpcoming) {
      sessionValues.push(dateobj.time);
    }
    return {
      detailLabel: sessionLabel,
      detailValues: sessionValues
    };
  })));
};
var ActionArea = function ActionArea(_ref) {
  var duration = _ref.duration,
    _ref$durationText = _ref.durationText,
    durationText = _ref$durationText === void 0 ? 'Duration' : _ref$durationText,
    _ref$language = _ref.language,
    language = _ref$language === void 0 ? [] : _ref$language,
    _ref$languageText = _ref.languageText,
    languageText = _ref$languageText === void 0 ? 'Language' : _ref$languageText,
    sessions = _ref.sessions,
    sessionText = _ref.sessionText,
    presentedText = _ref.presentedText,
    url = _ref.url,
    _ref$learnMoreCta = _ref.learnMoreCta,
    learnMoreCta = _ref$learnMoreCta === void 0 ? 'Learn More' : _ref$learnMoreCta,
    type = _ref.type;
  var classes = useStyles();
  var sessionsList = type === 'ondemand' && sessions ? [sessions[0]] : sessions;
  var sessionsListProps = {
    duration: duration,
    durationText: durationText,
    language: language,
    languageText: languageText,
    sessionsList: sessionsList,
    sessionText: sessionText,
    presentedText: presentedText
  };
  return __jsx("div", {
    className: classes.actionArea
  }, __jsx("dl", {
    className: classes.details
  }, buildSessionDetailList(sessionsListProps, type).map(function (sessionDetail, i) {
    return __jsx(_ListItem.default, (0, _extends2.default)({}, sessionDetail, {
      key: "aa-item-".concat(i)
    }));
  })), __jsx(_core.Button, {
    className: classes.ctaLink,
    variant: "contained",
    color: "primary",
    href: url
  }, __jsx("span", {
    dangerouslySetInnerHTML: {
      __html: learnMoreCta
    }
  })));
};
var _default = ActionArea;
exports.default = _default;